var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-loading"},[_c('div',{staticClass:"image",style:(`background-image: url(/loading/step-${_vm.state}.svg)`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }